import { GIFT_TYPE } from '@/enums/gift'

export const SKIN_MODE = [{ label: '系统模版-默认皮肤', value: 'default' }]

export const CREDIT = 'credit'
export const DRAW_QUALIFICATION = 'draw_qualification'

export const PRIZE_TYPE = [
  ...GIFT_TYPE.options(),
  { label: '会员积分', value: CREDIT, desc: '请输入积分值' },
  { label: '抽奖资格', value: DRAW_QUALIFICATION, desc: '请选择活动' },
  { label: '谢谢参与', value: 'none', desc: '谢谢参与' }
]

export const COLOR_REG = Object.freeze(/^#[0-9a-zA-Z]{6}$/)

export const CONTINUITY_SIGN = 'continuity' //连签
export const ACCUMULATE_SIGN = 'accumulate' //累签
export const FIRST_SIGN = 'first' //首签

export const LOOP = 'loop'
export const LADDER = 'ladder'

export const INVITE_MODE = [
  { label: '循环邀请 (每邀请N人时可获得奖励,可配置邀请上限) ', value: LOOP },
  { label: '阶梯邀请 (邀请人数达到某个阶段时,可获得该阶段的奖励)', value: LADDER }
]

export const CHECK_COLOR = (rule, value, callback) => {
  if (!COLOR_REG.test(value)) {
    callback(new Error('请输入正确的颜色'))
  }
  callback()
}

export const PRIZE_GRADE = Object.freeze({
  FIRST: 'first',

  SECOND: 'second',

  THIRD: 'third',

  FOURTH: 'fourth',

  FIFTH: 'fifth',

  SIXTH: 'sixth',

  SEVENTH: 'seventh',

  ZERO: 'zero',

  options() {
    return [
      { label: '一等奖', value: this.FIRST },
      { label: '二等奖', value: this.SECOND },
      { label: '三等奖', value: this.THIRD },
      { label: '四等奖', value: this.FOURTH },
      { label: '五等奖', value: this.FIFTH },
      { label: '六等奖', value: this.SIXTH },
      { label: '七等奖', value: this.SEVENTH },
      { label: '谢谢参与', value: this.ZERO }
    ]
  }
})

export const ACTIVITY_TYPE = Object.freeze({
  TURNPLATE: 'turnplate',
  SUDOKU: 'sudoku'
})

/**
 * 互动数据统计 用户信息筛选条件
 */
export const USER_SEARCH = Object.freeze({
  /**
   * 用户昵称
   */
  nickname: 'nickName',
  /**
   * 手机号码
   */
  phone_number: 'phoneNumber',

  options() {
    return [
      { label: '用户昵称', value: this.nickname },
      { label: '手机号码', value: this.phone_number }
    ]
  }
})

/**
 * 题型信息
 */
export const questionType = Object.freeze({
  /**
   * 单选题
   */
  single_choice: 'single_choice',
  /**
   * 多选题
   */
  multiple_choice: 'multiple_choice',
  /**
   * 下拉单选
   */
  drop_down: 'drop_down',
  /**
   * 下拉多选
   */
  cascade_drop_down: 'cascade_drop_down',
  /**
   * 矩形选择
   */
  likert: 'likert ',
  /**
   * 填空题
   */
  single_line_text: 'single_line_text',
  /**
   * 简答题
   */
  paragraph_text: 'paragraph_text',
  /**
   * 数字
   */
  number: 'number',
  /**
   * 横向填空
   */
  multiple_blanks: 'multiple_blanks',
  /**
   * 评分
   */
  rating: 'rating',
  /**
   * nps题
   */
  nps: 'nps',
  /**
   * 矩阵量表
   */
  matrix_scale: 'matrix_scale',
  /**
   * 排序题
   */
  sort: 'sort',
  /**
   * 收集附件
   */
  attachment: 'attachment',
  /**
   * 邮箱
   */
  email: 'email',
  /**
   * 手机
   */
  mobile: 'mobile',
  /**
   * 固话
   */
  phone: 'phone',
  /**
   * 地址
   */
  address: 'address',
  /**
   * 分页
   */
  page_break: 'page_break',
  /**
   * 描述
   */
  section_break: 'section_break',
  /**
   * 时间
   */
  time: 'time',
  /**
   * 日期
   */
  date_time: 'date_time',
  /**
   * 地理位置
   */
  geo_location: 'geo_location',
  /**
   *
   */
  link: 'link',
  /**
   * 矩形填空
   */
  matrix: 'matrix',
  /**
   * 表格填空
   */
  table: 'table',
  /**
   * 签名
   */
  e_signature: 'e_signature',

  options() {
    return [
      { label: '单选题', value: this.single_choice, group: '' },
      { label: '多选题', value: this.multiple_choice, group: '' },
      { label: '下拉单选', value: this.drop_down, group: '' },
      { label: '下拉多选', value: this.cascade_drop_down, group: '' },
      { label: '矩形选择', value: this.likert, group: '' },
      { label: '填空题', value: this.single_line_text, group: '' },
      { label: '简答题', value: this.paragraph_text, group: '' },
      { label: '数字', value: this.number, group: '' },
      { label: '横向填空', value: this.multiple_blanks, group: '' },
      { label: '评分', value: this.rating, group: '' },
      { label: 'nps题', value: this.nps, group: '' },
      { label: '矩阵量表', value: this.matrix_scale, group: '' },
      { label: '排序题', value: this.sort, group: '' },
      { label: '收集附件', value: this.attachment, group: '' },
      { label: '邮箱', value: this.email, group: '' },
      { label: '手机', value: this.mobile, group: '' },
      { label: '固话', value: this.phone, group: '' },
      { label: '地址', value: this.address, group: '' },
      { label: '分页', value: this.page_break, group: '' },
      { label: '描述', value: this.section_break, group: '' },
      { label: '时间', value: this.time, group: '' },
      { label: '日期', value: this.date_time, group: '' },
      { label: '地理位置', value: this.geo_location, group: '' },
      { label: '网址', value: this.link, group: '' },
      { label: '矩形填空', value: this.matrix, group: '' },
      { label: '表格填空', value: this.table, group: '' },
      { label: '签名', value: this.e_signature, group: '' }
    ]
  },
  filter(value) {
    return this.options.find(item => item.value === value) || {}
  },
  filterImg(value) {
    return this.options.find(item => item.group === 'img' && item.value === value)
  },
  filterVideo(value) {
    return this.options.find(item => item.group === 'video' && item.value === value)
  }
})
